export default __webpack_public_path__ + "static/media/iconesMeusDadosMaior.8a50bcd0.png";